"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialFeaturesState = {
  payments: false
};